import { render, staticRenderFns } from "./CompanyEdit.vue?vue&type=template&id=b979d548&"
import script from "./CompanyEdit.vue?vue&type=script&lang=js&"
export * from "./CompanyEdit.vue?vue&type=script&lang=js&"
import style0 from "./CompanyEdit.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports